import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Icon, List, iconChevron } from '@sauda/ui/kit';
import { Screen } from '../../app/chrome.js';
import { settingsPagesFor } from '../../app/nav.js';
import { useAuth } from '../../auth/AuthContext.js';

/** One place for everything about the agency: its brand, people, branches, partners and billing. */
export function SettingsScreen() {
  const { t } = useTranslation();
  const auth = useAuth();
  const role = auth.current?.role;
  const pages = role === undefined ? [] : settingsPagesFor(role);
  const rows = [
    ...pages.map((d) => ({
      key: d.key,
      path: d.path,
      title: t(d.label),
      hint: t(`settings.${d.key}Hint`),
    })),
    {
      key: 'sessions',
      path: '/account/sessions',
      title: t('nav.sessions'),
      hint: t('settings.sessionsHint'),
    },
    { key: 'help', path: '/help', title: t('nav.help'), hint: t('settings.helpHint') },
  ];
  return (
    <Screen title={t('nav.settings')} large eyebrow={auth.current?.agencyName}>
      <List>
        {rows.map((r) => (
          <li key={r.key} className="k-list__item">
            <Link className="k-list__row k-layer" to={r.path}>
              <span className="k-list__text">
                <span className="k-t-title-sm">{r.title}</span>
                <span className="k-t-body-md k-muted">{r.hint}</span>
              </span>
              <Icon icon={iconChevron} />
            </Link>
          </li>
        ))}
      </List>
    </Screen>
  );
}
